import * as React from "react";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Box,
  useMediaQuery,
  Theme,
  Button,
  Divider,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import GavelIcon from "@mui/icons-material/Gavel";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import HomeIcon from '@mui/icons-material/Home';
import InstagramIcon from '@mui/icons-material/Instagram'; // Importamos el icono de Instagram

import { useAuth } from "./AuthContext";
import AppRouter from "./router";
import { AddCircleOutline } from "@mui/icons-material";

export default function DashboardLayout() {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [bottomNavValue, setBottomNavValue] = React.useState(0);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));
  const userinfo: any = JSON.parse(localStorage.getItem("usuario") || "{}");

  const logout1 = () => {
    localStorage.removeItem("usuario");
    localStorage.removeItem("token");
    sessionStorage.clear();
    logout();
  };

  const handleInstagramClick = () => {
    window.open("https://www.instagram.com/chicosxbaires", "_blank");
  };

  React.useEffect(() => {
    if (!isMobile) {
      setDrawerOpen(true);
    }
  }, [isMobile]);

  const AfterMenuClick = () => {
    if (isMobile) {
      setDrawerOpen(false);
    }
  };

  const handleBottomNavChange = (event: React.SyntheticEvent, newValue: number) => {
    setBottomNavValue(newValue);
  };

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          width: `calc(100% - ${drawerOpen && !isMobile ? 240 : 0}px)`,
          transition: "width 0.3s ease",
          backgroundColor: "#1f546c",
        }}
      >
        <Toolbar>
          {!isMobile && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={() => setDrawerOpen(!drawerOpen)}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <img src="/logo192.png" style={{ width: 120 }} />
        </Toolbar>
      </AppBar>

      {/* Menú lateral (solo para desktop) */}
      {!isMobile && (
        <Drawer
          variant="persistent"
          open={drawerOpen}
          sx={{
            width: drawerOpen ? 240 : 0,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: 240,
              boxSizing: "border-box",
              backgroundColor: "#1f546c",
              color: "white",
            },
          }}
        >
          <Toolbar />
          <List>
            <ListItem sx={{ color: "white" }}>{userinfo?.email}</ListItem>

            {user ? (
              <ListItem
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  color: "white",
                }}
              >
                <Button color="inherit" onClick={logout1}>
                  Cerrar sesión
                </Button>
              </ListItem>
            ) : (
              <ListItem
                sx={{ color: "white" }}
                component={Link}
                to="/login"
                onClick={() => AfterMenuClick()}
              >
                <ListItemIcon>
                  <AccountCircleIcon sx={{ color: "white" }} />
                </ListItemIcon>
                <ListItemText primary="Iniciar sesión" />
              </ListItem>
            )}
            <Divider sx={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }} />
            <ListItem
              sx={{ color: "white" }}
              component={Link}
              to="/"
              onClick={() => AfterMenuClick()}
            >
              <ListItemIcon>
                <MapsHomeWorkIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary="Inicio" />
            </ListItem>

            <ListItem
              component={Link}
              to="/eventos"
              sx={{ color: "white" }}
              onClick={() => AfterMenuClick()}
            >
              <ListItemIcon>
                <CalendarMonthIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary="Eventos" />
            </ListItem>

            <ListItem
              component={Link}
              to="/create"
              sx={{ color: "white" }}
              onClick={() => AfterMenuClick()}
            >
              <ListItemIcon>
                <AddLocationAltIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary="Crear Lugar" />
            </ListItem>
          </List>
          <Box sx={{ mt: 'auto' }}>
            <Divider sx={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }} />
            {/* Botón de Instagram para web */}
            <ListItem
              
              onClick={handleInstagramClick}
              sx={{ color: "white" }}
            >
              <ListItemIcon>
                <InstagramIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText primary="Síguenos en Instagram" />
            </ListItem>
            <ListItem
              component={Link}
              to="/privacidad"
              sx={{ color: "white" }}
              onClick={() => AfterMenuClick()}
            >
              <ListItemText primary="Avisos Legales" />
            </ListItem>
          </Box>
        </Drawer>
      )}

      {/* Contenido principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          height: "100vh",
          overflowY: "auto",
          paddingBottom: isMobile ? "56px" : "0", // Espacio para el bottom nav
        }}
      >
        <Toolbar />
        <AppRouter />
      </Box>

      {/* Bottom Navigation (solo para mobile) */}
      {isMobile && (
        <Paper
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          elevation={3}
        >
          <BottomNavigation
            showLabels
            value={bottomNavValue}
            onChange={handleBottomNavChange}
            sx={{ backgroundColor: "#1f546c", color: "white" }}
          >
            <BottomNavigationAction
              label="Inicio"
              icon={<HomeIcon sx={{ color: "white" }} />}
              component={Link}
              to="/"
              sx={{ color: "white" }}
            />
            <BottomNavigationAction
              label="Eventos"
              icon={<CalendarMonthIcon sx={{ color: "white" }} />}
              component={Link}
              to="/eventos"
              sx={{ color: "white" }}
            />
            <BottomNavigationAction
              label="Crear"
              icon={<AddLocationAltIcon sx={{ color: "white" }} />}
              component={Link}
              to="/create"
              sx={{ color: "white" }}
            />
            {/* Botón de Instagram para móvil */}
            <BottomNavigationAction
              label="Instagram"
              icon={<InstagramIcon sx={{ color: "white" }} />}
              onClick={handleInstagramClick}
              sx={{ color: "white" }}
            />
            {user ? (
              <BottomNavigationAction
                label="Salir"
                icon={<AccountCircleIcon sx={{ color: "white" }} />}
                onClick={logout1}
                sx={{ color: "white" }}
              />
            ) : (
              <BottomNavigationAction
                label="Ingresar"
                icon={<AccountCircleIcon sx={{ color: "white" }} />}
                component={Link}
                to="/login"
                sx={{ color: "white" }}
              />
            )}
          </BottomNavigation>
        </Paper>
      )}
    </Box>
  );
}